<script setup lang="ts">
/**
 * Circular color swatch picker. Renders a grid of colored circles —
 * the selected one gets a ring. Used for tags and item types.
 *
 * Colors are Tailwind color names (e.g. "blue", "green") that map
 * to bg-{color}-600 hex values via COLOR_HEX.
 */
import { colorHex } from "@/lib/colors"

defineProps<{
  /** Available color keys (e.g. ["blue", "green", "purple"]) */
  colors: string[]
  /** Currently selected color key */
  modelValue: string
}>()

const emit = defineEmits<{
  "update:modelValue": [value: string]
}>()
</script>

<template>
  <div role="radiogroup" aria-label="Color" class="flex flex-wrap gap-2">
    <button
      v-for="color in colors"
      :key="color"
      type="button"
      role="radio"
      class="size-10 rounded-full transition-shadow"
      :class="modelValue === color ? 'ring-primary ring-2 ring-offset-2' : ''"
      :style="{ backgroundColor: colorHex(color) }"
      :aria-label="`${color} color`"
      :aria-checked="modelValue === color"
      @click="emit('update:modelValue', color)"
    />
  </div>
</template>
